import React from 'react';

function CallToAction({ callToActionText, callToActionLink, callToActionCssClass = '' }) {
  if (!callToActionText || !callToActionLink) { return null; }

  return (
    <div>
      <a
        href={callToActionLink}
        title={callToActionText}
        className={`button ${callToActionCssClass}`}
      >
        {callToActionText}
      </a>
    </div>
  );
}

CallToAction.propTypes = {
  callToActionText: React.PropTypes.string,
  callToActionLink: React.PropTypes.string,
  callToActionCssClass: React.PropTypes.string
};

export default CallToAction;



// WEBPACK FOOTER //
// ./components/callToAction.js